const agentNameColumn = ({
	name = "agentName",
	placeholder = "Agent Name",
} = {}) => ({
	name,
	type: "input" as const,
	placeholder,
});

export default agentNameColumn;
